import React from "react";
import { FaCommentAlt, FaRegCommentAlt } from "react-icons/fa";
import Book from "./Book/Book";
import "./Bookings.css";
import DashMenu from "../../../../atoms/DashMenu/DashMenu";
import SubHeader from "../../../../atoms/SubHeader/SubHeader";

const Bookings = ({ toggleMenu, showMenu }) => {
  return (
    <div className="dashboard-home-wrapper">
      <div className="dashmenu-style">
        <DashMenu toggleMenu={toggleMenu} showMenu={showMenu} />
      </div>{" "}
      <SubHeader title={"BOOKINGS"}/>
      <div className="book-message-content-wrapper">
        <div className="book-box book-box1">
          <div className="message-header">
            <div className="msg-left">
              <FaCommentAlt className="userprofile" />
              <h3>Last Bookings</h3>
              <h4>(+3 New)</h4>
            </div>
            <div className="msg-right">
              <FaRegCommentAlt className="userprofile" />
            </div>
          </div>
        </div>
        <div className="book-box book-box2">
          <Book />
        </div>
      </div>
    </div>
  );
};

export default Bookings;
